import { Globe2, Trophy } from 'lucide-react';
import { LEGACY_STATS } from '../constants/restaurant';

export const Legacy = () => {
  return (
    <section
      data-testid="legacy-section"
      className="relative bg-brand-coffee text-brand-cream py-24 md:py-32 px-6 md:px-12 lg:px-16 overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay opacity-30" />
      <div
        className="absolute inset-0 opacity-20 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/35539315/pexels-photo-35539315.jpeg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-brand-coffee via-brand-coffee/95 to-brand-coffee/80" />

      <div className="relative max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <p className="text-xs uppercase tracking-[0.3em] font-semibold text-brand-gold mb-6">
            Our Legacy
          </p>
          <h2
            data-testid="legacy-heading"
            className="font-serif text-4xl sm:text-5xl lg:text-[64px] leading-[1.05] tracking-tight"
          >
            A globally loved <span className="italic text-brand-gold">South Indian</span>{' '}
            name — now on the Sunshine Coast.
          </h2>
          <p
            data-testid="legacy-paragraph"
            className="mt-8 text-base md:text-lg text-brand-cream/80 leading-[1.8] max-w-2xl"
          >
            Sankalp is a globally recognised South Indian restaurant brand with over 250
            locations worldwide. Famous for its iconic dosas, the brand has also gained
            international recognition for creating record-breaking dosas — including a
            Guinness World Record for the world&apos;s longest dosa.
          </p>

          <div className="mt-10 inline-flex items-center gap-4 px-5 py-3 rounded-full bg-brand-gold/15 border border-brand-gold/30">
            <Trophy className="w-5 h-5 text-brand-gold" />
            <span className="text-sm font-semibold tracking-wide text-brand-cream">
              Guinness World Record · World&apos;s Longest Dosa
            </span>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="grid grid-cols-1 gap-4">
            {LEGACY_STATS.map((stat, i) => (
              <div
                key={stat.label}
                data-testid={`legacy-stat-${i}`}
                className="flex items-center justify-between gap-6 px-7 py-6 rounded-2xl bg-brand-cream/5 border border-brand-cream/15 backdrop-blur-md hover:bg-brand-cream/10 transition-colors duration-500"
              >
                <div>
                  <p className="font-serif text-5xl md:text-6xl text-brand-gold leading-none">
                    {stat.value}
                  </p>
                  <p className="text-[11px] uppercase tracking-[0.25em] text-brand-cream/70 font-semibold mt-3">
                    {stat.label}
                  </p>
                </div>
                <Globe2 className="w-10 h-10 text-brand-cream/40" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Legacy;
